"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamErrors = void 0;
var StreamErrors;
(function (StreamErrors) {
    StreamErrors["INAPPROPRIATE_CONTENT"] = "400 Bad request: inappropriate content";
    StreamErrors["UNAUTHORIZED"] = "401 Unauthorized";
    StreamErrors["FORBIDDEN"] = "403 Forbidden";
    StreamErrors["CONVERSATION_LENGTH_LIMIT_HIT"] = "413 Content too large: conversation length limit hit";
    StreamErrors["INVALID_BODY_FIELD_TEXT"] = "422 Invalid body field: text";
    StreamErrors["INVALID_BODY"] = "422 Invalid body";
    StreamErrors["UNSUPPORTED_REGION"] = "Unsupported region";
    StreamErrors["UNKNOWN"] = "Something went wrong in response stream";
    StreamErrors["FILE_RESOURCE_NOT_FOUND"] = "File resource not found";
})(StreamErrors = exports.StreamErrors || (exports.StreamErrors = {}));
//# sourceMappingURL=StreamErrors.js.map